import { StepConfig } from '../../../../models';
import { ConfigTreeNode } from '../models';

// accepts a list of step configs and build a tree of step configs
export function buildStepConfigTree(stepConfigs: StepConfig[]): Map<string, ConfigTreeNode> {
  const stepMap = new Map<string, ConfigTreeNode>();
  // build the map first
  for (const stepConfig of stepConfigs) {
    const stepConfigNode = {
      config: stepConfig,
      stepInstances: []
    };
    stepMap.set(stepConfig.name, stepConfigNode);
  }

  // add the parent to the config nodes
  for (const stepConfig of stepConfigs) {
    if (stepConfig.needs?.name) {
      const currentNode = stepMap.get(stepConfig.name);
      if (currentNode === undefined) {
        throw new Error(`Could not find node for step ${stepConfig.name}`);
      }
      const parentNode = stepMap.get(stepConfig.needs.name);
      if (parentNode) {
        currentNode.parent = parentNode;
      }
    }
  }
  return stepMap;
}
